import SeoHead from "../components/SeoHead";
import { PageHeader } from "./Services";
import { SITE } from "../lib/site";

export default function MentionsLegales() {
  return (
    <div data-testid="legal-page">
      <SeoHead
        title="Mentions légales | Termite Bordeaux"
        description="Mentions légales du site termitebordeaux.fr."
        canonical={SITE.url + "/mentions-legales"}
        noindex
      />
      <PageHeader eyebrow="Mentions légales" title="Mentions légales & informations éditoriales." />
      <section className="container-x py-16 max-w-3xl prose-article">
        <h2>Éditeur</h2>
        <p>
          Le site termitebordeaux.fr est édité par {SITE.name}, cabinet d'expertise spécialisé dans le
          traitement des termites et du bois en Gironde. Siège : {SITE.address}, {SITE.postalCode}{" "}
          {SITE.city.toUpperCase()}. Téléphone : {SITE.phone}. Email : {SITE.email}.
        </p>
        <h2>Hébergement</h2>
        <p>Service hébergé via une infrastructure cloud sécurisée européenne.</p>
        <h2>Propriété intellectuelle</h2>
        <p>
          L'ensemble des contenus (textes, photographies, mises en page, graphismes) présents sur ce
          site sont la propriété exclusive de leur auteur et sont protégés par le droit d'auteur.
          Toute reproduction sans autorisation expresse est interdite.
        </p>
        <h2>Données personnelles</h2>
        <p>
          Les informations saisies dans nos formulaires sont utilisées exclusivement pour traiter
          votre demande. Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et
          de suppression sur simple demande à {SITE.email}.
        </p>
        <h2>Société associée</h2>
        <p>
          Pour découvrir nos réalisations complètes, voir également :{" "}
          <a href={SITE.parentSite} target="_blank" rel="noopener noreferrer">{SITE.parentSiteLabel}</a>.
        </p>
      </section>
    </div>
  );
}
